import { handleActions } from 'redux-actions';
import { authSet } from 'store/actionCreators/auth';

const defaultState = {
  authenticated: null,
};

export default handleActions(
  {
    [authSet]: (state, { payload: { authenticated } }) => ({
      authenticated,
    }),
  },
  defaultState,
);
